import React from 'react';
import { inject, observer } from 'mobx-react';
import s from './index.less';
import { Icon } from '@/components';
import { useIntl } from 'umi';
interface LoadingTipProps {}

const LoadingTip: React.FC<LoadingTipProps> = inject()(
  observer((props: LoadingTipProps) => {
    const { formatMessage } = useIntl();
    return (
      <div className={s.container}>
        <Icon name="icon-statusLoading_1" mode="symbol" size={20} spin className={s.icon}></Icon>
        <span className={s.text}>{formatMessage({ id: 'isEnablingSubtitles' })} </span>
      </div>
    );
  })
);

export default LoadingTip;
